import { IPrismicComponentBody } from './usePrismicComponentBody';
import { IHeadingSubNav } from '../utils/declarations';

const usePrismicComponentHeadings = (demos?: IPrismicComponentBody[]) => {
  const headings: IHeadingSubNav[] = [];
  const headingTypes = ['heading2', 'heading3'];
  if (demos.length) {
    demos.forEach(({ primary, fields }) => {
      if (
        primary?.demo_title !== null &&
        primary?.demo_title[0] !== undefined &&
        primary?.demo_title[0].text
      ) {
        const value = primary.demo_title[0].text;
        const anchor = value.replace(/\s+/g, '-').toString().toLowerCase();
        headings.push({
          anchor,
          value,
        });
      }

      primary?.demo_description?.forEach(({ type, text }) => {
        if (headingTypes.includes(type)) {
          const anchor = text.replace(/\s+/g, '-').toString().toLowerCase();
          headings.push({
            anchor,
            value: text,
          });
        }
      });

      fields?.forEach(({ demo_summary }) => {
        demo_summary?.forEach(({ type, text }) => {
          if (headingTypes.includes(type)) {
            const anchor = text.replace(/\s+/g, '-').toString().toLowerCase();
            headings.push({
              anchor,
              value: text,
            });
          }
        });
      });
    });
  }
  return headings;
};

export default usePrismicComponentHeadings;
